export default __webpack_public_path__ + "static/media/finishStar.c9ba03be.png";